import axios from 'services/index';
import config from 'config/config';

/**
 * @param {Object} email Email of the user to login
 * @param {Object} password Password of the user to login
 */
export async function getPetTypeList() {
    return axios.get(`${config.API_URL}portal/pet_types`);
}

/**
 * Gets the pet breed list from the API
 * 
 * @param {Object} petType Pet type 
 * @param {Number} page Page to be requested
 * @param {String} search Search keyword
 * 
 * @returns {Promise} Pet breed list pagination response
 */
export async function getPetBreedList(petType, page = 1, search = '') {
    return axios.get(`${config.API_URL}portal/pet_breeds?pet_type=${petType}&search=${search}&page=${page}`);
}
